import "./SuccessfullResetPasswordComponent.scss";
import React from "react";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import {useNavigate} from "react-router-dom";
import commonService from "../../../shared/services/common.service";
import {ImageConfig} from "../../../constants";

interface SuccessfullResetPasswordComponentProps {

}

const SuccessfullResetPasswordComponent = (props: SuccessfullResetPasswordComponentProps) => {
    const navigate = useNavigate();
    return (
        <div className={'successfull-reset-password-component screen width-100'}>
            <div className="successfull-reset-password-title auth-form-title">
                Password Reset Successful!
            </div>
            <div className="successfull-reset-password-description auth-form-description">
                Your password has been successfully reset. Please click on proceed to log into your account.
            </div>
            <div className={'successful-reset-gif-and-actions-wrapper'}>
                <img src={ImageConfig.SuccessfullPasswordReset} alt={'...loading'}/>
                <ButtonComponent
                    type={"button"}
                    size={"large"}
                    className={"mrg-top-20"}
                    fullWidth={true}
                    handleClick={() => {
                        navigate(commonService._routeConfig.LoginRoute())
                    }}
                >
                    Proceed to login
                </ButtonComponent>
            </div>
        </div>
    );

};

export default SuccessfullResetPasswordComponent;
